import { SVG_TOP_MARGIN, SVG_BOTTOM_PADDING } from './constants';
import { getTotalThickness } from './svgHelpers';

/**
 * Maksymalna głębokość rzędnej spośród otworów.
 */
export const getMaxDepth = (boreholes) => {
  return Math.max(...boreholes.map(b => b.depth));
};

/**
 * Maksymalna odległość pozioma spośród otworów.
 */
export const getMaxDistance = (boreholes) => {
  return Math.max(...boreholes.map(b => b.distance || 0));
};

/**
 * Oblicza wysokość SVG na podstawie otworów i skali.
 */
export const getSvgHeight = (boreholes, scale) => {
  const pixelsPerMeter = scale / 10;
  const maxDepth = getMaxDepth(boreholes);

  let lowestY = SVG_TOP_MARGIN;
  boreholes.forEach(borehole => {
    const depthOffset = (maxDepth - borehole.depth) * pixelsPerMeter;
    const boreholeBottom = SVG_TOP_MARGIN + depthOffset + getTotalThickness(borehole.layers) * pixelsPerMeter;
    if (boreholeBottom > lowestY) {
      lowestY = boreholeBottom;
    }
  });

  return lowestY + SVG_BOTTOM_PADDING;
};

/**
 * Oblicza szerokość SVG na podstawie otworów i skali poziomej.
 */
export const getSvgWidth = (boreholes, horizontalScale) => {
  const maxDist = getMaxDistance(boreholes);
  // 100 (lewy margines) + maxDist * skala + 80 (szerokość otworu) + 120 (skala + etykiety)
  return maxDist * horizontalScale + 300;
};
